import { useMutation, useQuery } from "@tanstack/react-query";
import { Drawer } from "../shared/Drawer";
import { DynamicForm } from "../dynamicForm";
import { usePermission } from "../shared/permissions";
import { trackEvent } from "../shared/Snowplow";
import { DynamicGrid } from "../dynamicGrid";
import {
  sharedProcessingByIdQueryOptions,
  sharedProcessingFormQueryOptions,
  updateSharedProcessingAnswersMutationOptions,
} from "../api/sharedProcessings";
import { SharedProcessingDrawerHeader } from "./SharedProcessingDrawerHeader";

export const SharedProcessingGuidedDrawer = () => {
  const sharedProcessingId = DynamicGrid.useSelectedRowId();
  const sharedProcessingQuery = useQuery(sharedProcessingByIdQueryOptions(sharedProcessingId));
  const formQuery = useQuery(sharedProcessingFormQueryOptions());
  const answersMutation = useMutation(updateSharedProcessingAnswersMutationOptions());
  const { hasPermission } = usePermission();

  return (
    <DynamicForm.MultiStepFormDialog>
      {(() => {
        if (!sharedProcessingQuery.data || !formQuery.data) return <Drawer.Loading />;

        const sharedProcessing = sharedProcessingQuery.data;
        return (
          <DynamicForm.Provider
            key={sharedProcessing.id}
            onSave={answer => {
              trackEvent.answerQuestionRegistrationGuidedView(answer.type);
              return answersMutation.mutateAsync({ id: sharedProcessing.id, answers: [answer] });
            }}
            answers={sharedProcessing.answers}
            isReadOnly={!hasPermission("nova-forms-api:enterprise-customers:registrations:manage")}
            isSaveError={answersMutation.isError}
            isSaving={answersMutation.isPending}
          >
            {({ formState }) => (
              <DynamicForm.Form
                header={
                  <SharedProcessingDrawerHeader
                    activeTab="guided"
                    sharedProcessing={sharedProcessing}
                    statusIndicator={DynamicForm.formStateToDrawerHeaderStatus(formState)}
                  />
                }
                form={formQuery.data}
              />
            )}
          </DynamicForm.Provider>
        );
      })()}
    </DynamicForm.MultiStepFormDialog>
  );
};
